import Navbar from 'components/Navbar';
import Tab from 'components/admin/Tab';
import classes from './Admin.module.scss';

export default function Admin() {
  return (
    <div className={classes.root}>
      <Navbar />
      <main className={classes.content}>
        <Tab />
      </main>
    </div>
  );
}
